import { useState } from 'react';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Home } from './components/Home';
import { Quiz } from './components/Quiz';
import { Results } from './components/Results';
import { quizQuestions } from './data/quizData';
import { useQuizGame } from './hooks/useQuizGame';
import { shuffleArray } from './utils/helpers';

type GameScreen = 'home' | 'quiz' | 'results';

function App() {
  const [screen, setScreen] = useState<GameScreen>('home');
  const [shuffledQuestions] = useState(() => shuffleArray(quizQuestions));

  const {
    gameState,
    currentQuestion,
    selectedOption,
    showExplanation,
    handleAnswer,
    nextQuestion,
    resetGame,
    getStats,
    progress,
  } = useQuizGame(shuffledQuestions);

  const handleStart = () => {
    setScreen('quiz');
  };

  const handleNext = () => {
    nextQuestion();
    if (gameState.currentQuestionIndex + 1 >= shuffledQuestions.length) {
      setScreen('results');
    }
  };

  const handleRestart = () => {
    resetGame();
    setScreen('home');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-grow">
        {screen === 'home' && <Home onStart={handleStart} />}

        {screen === 'quiz' && (
          <Quiz
            question={currentQuestion}
            currentIndex={gameState.currentQuestionIndex}
            totalQuestions={shuffledQuestions.length}
            progress={progress}
            selectedOption={selectedOption}
            showExplanation={showExplanation}
            onAnswer={handleAnswer}
            onNext={handleNext}
          />
        )}

        {screen === 'results' && (
          <Results
            stats={getStats()}
            answers={gameState.answers}
            questions={shuffledQuestions}
            onRestart={handleRestart}
          />
        )}
      </main>

      <Footer />
    </div>
  );
}
export default App;
